import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ProposalRepository } from '../infra/ProposalRepository'

export type ToggleAutoSubmitProposalFactoryDependencies = {
  repository: ProposalRepository
}

type AbortConfig = { signal: AbortSignal }

export function toggleAutoSubmitProposalFactory({
  repository,
}: ToggleAutoSubmitProposalFactoryDependencies) {
  return async function toggleAutoSubmit(rfpId: string, autoSubmit: boolean, config: AbortConfig) {
    try {
      return await repository.toggleAutoSubmitProposal(rfpId, autoSubmit, config)
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not toggle proposal auto submit', { cause: error as Error })
    }
  }
}

export function toggleAutoSubmitProposal(rfpId: string, autoSubmit: boolean, config: AbortConfig) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ProposalRepository({ httpClient })
  const submit = toggleAutoSubmitProposalFactory({ repository })

  return submit(rfpId, autoSubmit, config)
}
